import utils from "../../../src/js/utils";

var list = {
	els: document.querySelectorAll(".vertical-carousel-block"), //FIXME: just one
	set: {
		slider: function () {
			utils.forEach(list.els, function (index, carousel) {
				var verticalCarosuelText = carousel.querySelector(
						".vertical-carousel-text"
					),
					verticalCarosuelImage = carousel.querySelector(
						".vertical-carousel-image"
					),
					isInitialized =
						verticalCarosuelText.classList.contains("is-initialized"),
					elemsNumber =
						verticalCarosuelText.querySelectorAll(".splide__slide").length,
					elems = verticalCarosuelText.querySelectorAll(
						".splide__slide .content"
					),
					endValue,
					scrollHeight = 0,
					totalScrollHeight = 0;

				if (elems.length > 0) {
					utils.forEach(elems, function (index, elem) {
						totalScrollHeight = totalScrollHeight + (elem.offsetHeight + 110);

						if (elem.offsetHeight > scrollHeight) {
							scrollHeight = elem.offsetHeight + 150;
						}
					});
				}

				if (elemsNumber > 1 && !isInitialized) {
					window.splideText = new Splide(verticalCarosuelText, {
						direction: "ttb",
						height: scrollHeight + "px",
						vericalHeight: true,
						perPage: 1,
						padding: "1rem",
						speed: 2000,
						pagination: false,
						drag: false,
						arrows: false,
						easing: "ease",
						updateOnMove: true,
						verticalWidth: true,
						focus: 0,
						omitEnd: true,
						breakpoints: {
							768: {
								destroy: true,
							},
						},
					});

					window.splideImage = new Splide(verticalCarosuelImage, {
						type: "fade",
						isNavigation: true,
						perPage: 1,
						speed: 2000,
						updateOnMove: true,
						pagination: false,
						drag: false,
						arrows: false,
					});

					// Sincronizzo i due caroselli
					window.splideText.sync(window.splideImage);

					var wrapper = carousel.closest("section"),
						progressBar = carousel.querySelector(".progress"),
						innerProgressBar = carousel.querySelector(".inner-progress"),
						topValue = "0px";

					progressBar.appendChild(document.createElement("i"));

					for (let index = 0; index < elemsNumber; index++) {
						progressBar.appendChild(document.createElement("span"));
					}

					var slideIndex = 0,
						slideIndexPart = 1,
						slidePart = 1 / elemsNumber;

					if (utils.screen.width > 768) {
						gsap.timeline({
							scrollTrigger: {
								trigger: wrapper,
								id: "drag-" + index,
								start: "top-=80px " + topValue,
								end: endValue,
								scrub: true,
								pin: true,
								onUpdate: function (self) {
									if (
										self.progress > slidePart * slideIndexPart &&
										self.direction == 1
									) {
										slideIndex = slideIndex + 1;
										window.splideText.go(slideIndex);
										slideIndexPart = slideIndexPart + 1;
									}

									if (
										self.progress < slidePart * slideIndexPart - slidePart &&
										self.direction == -1
									) {
										slideIndex = slideIndex - 1;
										window.splideText.go(slideIndex);
										slideIndexPart = slideIndexPart - 1;
									}

									innerProgressBar.style.transform =
										"scale(" + self.progress + ",1)";
								},
							},
						});

						const refreshObserver = new IntersectionObserver(function (
							entries
						) {
							entries.forEach(function (entry) {
								if (entry.isIntersecting || entry.intersectionRatio > 0) {
									ScrollTrigger.getById("drag-" + index).refresh();
									refreshObserver.unobserve(entry.target);
								}
							});
						});

						refreshObserver.observe(carousel);
					}

					window.splideText.mount();
					window.splideImage.mount();
				} else {
					carousel.classList.add("no-slider");
				}
			});
		},
		progress: function (progressBar, progress, translate) {
			if (!translate) {
				progressBar.style.transform = "scale(" + progress + ", 1)";
			} else {
				var trans = Math.min((-1 * progress.val) / progress.total, 1);
				progressBar.style.transform = "scale(" + trans + ", 1)";
			}
		},
	},
	init: function () {
		if (list.els.length > 0 && !utils.isMobile()) {
			list.set.slider();
		}
	},
};

utils.domReady(function () {
	list.init();
});
